<template>
  <VSheet
    :color="color"
    :rounded="rounded"
    :max-width="maxWidth"
    :min-width="minWidth"
    :width="width"
    :height="height"
    :border="border"
  >
    <slot />
  </VSheet>
</template>

<script setup lang="ts">
import { VSheet } from 'vuetify/components/VSheet';

export interface Props {
  color?: string;
  rounded?: 'xxl' | 'xl' | 'lg' | 'md' | 'sm' | 'pill' | false;
  maxWidth?: string | number | undefined;
  minWidth?: string | number | undefined;
  width?: string | number | undefined;
  height?: string | number | undefined;
  border?: string | number | boolean;
}

withDefaults(defineProps<Props>(), {
  color: undefined,
  rounded: false,
  maxWidth: undefined,
  minWidth: undefined,
  width: undefined,
  height: undefined,
  border: false,
});
</script>
